<template>
  <transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
    <slot />
  </transition>
</template>

<script>
// @vuese
// Animacja slide
// @group Animations
export default {
  name: 'Slide',
  methods: {
    // @vuese
    // Wywołane podczas wchodzenia elementu
    enter(element) {
      element.style.height = 'auto';
      element.style.visibility = 'hidden';

      const height = getComputedStyle(element).height;
      element.style.visibility = null;
      element.style.height = 0;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    // @vuese
    // Wywołane po wejściu elementu
    afterEnter(element) {
      element.style.height = 'auto';
    },
    // @vuese
    // Wywołane podczas wychodzenia elementu
    leave(element) {
      const height = getComputedStyle(element).height;

      element.style.height = height;

      setTimeout(() => {
        element.style.height = 0;
      });
    }
  }
};
</script>

<style>
.expand-enter-active,
.expand-leave-active {
  transition: height 0.4s ease-in-out;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  height: 0;
}
</style>

<style scoped>
* {
  will-change: height;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}
</style>
